"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useEffect } from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Jane Doe",
  company: "BuildRight Construction",
  quote: "AMPKORE revolutionized our project management process, saving us time and reducing scope gaps significantly.",
  rating: 5,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536499/img/testimonial_jane_doe_avatar.png"
}, {
  id: 2,
  name: "John Smith",
  company: "SecurePerimeter Inc.",
  quote: "The AI-powered insights provided by AMPKORE keep our projects on track and compliant.",
  rating: 5,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536499/img/testimonial_john_smith_avatar.png"
}, {
  id: 3,
  name: "Emily Chen",
  company: "ModernBuild Solutions",
  quote: "With AMPKORE, we've seen a 95% reduction in scope gaps. It's an absolute game changer for our team.",
  rating: 5,
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1536499/img/testimonial_emily_chen_avatar.png"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section id="testimonials" ref={ref} className={`py-16 px-4 sm:px-6 lg:px-8 bg-muted transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-foreground mb-4">
            What Our Clients Say
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Trusted by construction firms and project managers worldwide
          </p>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4">
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i} className="pl-4">
                <Card className="bg-background shadow-medium hover:shadow-strong transition-all duration-300 hover:-translate-y-1 border border-border">
                  <CardContent className="p-8">
                    <div className="flex items-start gap-4 mb-6">
                      <SafeHydrate><Avatar className="size-12 shrink-0">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.name} />
                        <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                          {testimonial.name.split(" ").map(n => n[0]).join("")}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="flex-1 min-w-0">
                        <h3 className="font-semibold text-foreground text-lg">
                          {testimonial.name}
                        </h3>
                        <p className="text-muted-foreground text-sm">
                          {testimonial.company}
                        </p>
                      </div>
                    </div>

                    <p className="text-foreground text-base leading-relaxed mb-6 italic">
                      "{testimonial.quote}"
                    </p>

                    <div className="flex gap-1" aria-label={`${testimonial.rating} out of 5 stars`}>
                      {Array.from({
                    length: 5
                  }).map((_, starIndex) => <Star key={starIndex} className={`size-5 ${starIndex < testimonial.rating ? "fill-accent text-accent" : "fill-muted text-muted"}`} />)}
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious className="hover:bg-primary hover:text-foreground-primary transition-colors duration-200" />
          <CarouselNext className="hover:bg-primary hover:text-foreground-primary transition-colors duration-200" />
        </Carousel>
      </div>
    </section>;
}